import React, { FC } from 'react';
import './styles.scss';

export const CandidateSkeleton: FC = () => {
  return (
    <div className="inbox-candidate-list-item-skeleton">
      <div className="inbox-candidate-list-item-skeleton__avatar-wrapper">
        <div className="inbox-candidate-list-item-skeleton__avatar pulse-fade" />
      </div>

      <div className="inbox-candidate-list-item-skeleton__info">
        <div className="inbox-candidate-list-item-skeleton__line inbox-candidate-list-item-skeleton__line--large pulse-fade" />

        <div className="inbox-candidate-list-item-skeleton__line inbox-candidate-list-item-skeleton__line--medium pulse-fade" />

        <div className="inbox-candidate-list-item-skeleton__line inbox-candidate-list-item-skeleton__line--small pulse-fade" />

        <div className="inbox-candidate-list-item-skeleton__line inbox-candidate-list-item-skeleton__line--large pulse-fade" />
      </div>
    </div>
  );
};
